import { get } from '@elementary/common-ui/utils/http';
import dayjs from 'dayjs';
import { DataPoint, Metric, MetricSource } from './types';

export const fetchMetrics = (envId: string): Promise<Metric[]> =>
  get(`${import.meta.env.VITE_API_BASE_URL}/${envId}/metrics/`);

export const fetchMetricDimensions = (
  envId: string,
  metricName: string,
  databaseName: string,
  schemaName: string,
  tableName: string,
  source: MetricSource,
  columnName?: string,
): Promise<string[]> =>
  get(`${window.VITE_API_BASE_URL}/${envId}/metrics/dimension-values`, {
    metric_name: metricName,
    database_name: databaseName,
    schema_name: schemaName,
    table_name: tableName,
    column_name: columnName,
    source,
  });

export const fetchDataPoints = (
  envId: string,
  metricName: string,
  databaseName: string,
  schemaName: string,
  tableName: string,
  source: MetricSource,
  startTime: dayjs.Dayjs,
  endTime: dayjs.Dayjs,
  columnName?: string,
  dimension?: string,
): Promise<DataPoint[]> =>
  get(`${window.VITE_API_BASE_URL}/${envId}/metrics/data-points`, {
    metric_name: metricName,
    database_name: databaseName,
    schema_name: schemaName,
    table_name: tableName,
    source,
    column_name: columnName,
    start_time: startTime.utc().format('YYYY-MM-DDTHH:mm:ss'),
    end_time: endTime.utc().format('YYYY-MM-DDTHH:mm:ss'),
    dimension,
  });
